module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_fair-79312b7711dc0d09c4e4f682f2ade29b.jpg";